import styled from 'styled-components';
import { Row } from 'components/Grid';
import { Colors } from 'styles/CssVariables';

const SAuthFormsWrapper = styled(Row)`
  max-width: 450px;
  width: 100%;
  .ant-statistic-content-value {
    color: ${Colors.ErrorColor};
  }
`;
export default SAuthFormsWrapper;
